import Model from 'flarum/common/Model';
/** Um emblema (`/api/canela-badges`). O nome e as descrições já vêm traduzidos pelo servidor. */
export default class Badge extends Model {
  slug() {
    return Model.attribute('slug').call(this);
  }
  name() {
    return Model.attribute('name').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  /** Só vem na página do emblema (`GET /api/canela-badges/:id`). */
  longDescription() {
    return Model.attribute('longDescription').call(this);
  }
  /** Imagem no lugar do ícone (admin); só depois da migração do admin de emblemas. */
  imageUrl() {
    return Model.attribute('imageUrl').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  type() {
    return Model.attribute('type').call(this);
  }
  grouping() {
    return Model.attribute('grouping').call(this);
  }
  position() {
    return Model.attribute('position').call(this);
  }
  multipleGrant() {
    return Model.attribute('multipleGrant').call(this);
  }
  /** Pode virar título no perfil de quem ganhou (só com a coluna do admin de emblemas). */
  allowTitle() {
    return Model.attribute('allowTitle').call(this);
  }
  system() {
    return Model.attribute('system').call(this);
  }
  enabled() {
    return Model.attribute('enabled').call(this);
  }
  listable() {
    return Model.attribute('listable').call(this);
  }
  /** Só para o admin: o fórum tem o que a regra precisa medir. */
  available() {
    return Model.attribute('available').call(this);
  }
  grantCount() {
    return Model.attribute('grantCount').call(this);
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/models/Badge', Badge);